module.exports = __webpack_public_path__ + "static/media/icon-1.1a6221f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/threats/3/icon-1.svg
// module id = 364
// module chunks = 0